














































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { accountPower } from "@/req/user";
@Component({
  components: {},
})
export default class Home extends Vue {
  public activeMenu = "";
  public menu: any = [];
  public created() {
    this.getPowerList();
    sessionStorage.setItem("path", `/${this.$route.name}`);
  }
  public async getPowerList() {
    const res = await accountPower({
      token: this.$fn.cookies.getToken("tpken"),
    });
    if (res.code == 0) {
      for (let i = 0; i < res.data.permission.length; i++) {
        if (res.data.permission[i].id == 82) {
          const str = res.data.permission[i];
          res.data.permission.splice(i, 1);
          res.data.permission.unshift(str);
        }
      }
      this.menu = res.data.permission;
      this.refreshSiderMenu();
    }
  }
  @Watch("$route")
  public routeChange() {
    sessionStorage.setItem("path", `/${this.$route.name}`);
    this.refreshSiderMenu();
  }
  public refreshSiderMenu() {
    this.$nextTick(() => {
      // iview的api手册中不能解决路由切换问题,通过currentActiveName可以解决
      (this.$refs.menu as any).currentActiveName = this.activeMenu =
        this.$route.path;
      (this.$refs.menu as any).updateActiveName();
      (this.$refs.menu as any).updateOpened();
      setTimeout(() => {
        const cls = ".home-sider .ivu-menu-item-active .ivu-menu-submenu-title";
        const subDom = document.querySelector(cls);
        const subList = document.querySelector(`${cls}+ul`);
        if (subDom && subList && (subList as any).style.display === "none") {
          subDom.click();
        }
      });
    });
  }
  public navigateTo(path) {
    this.toPage(path, this.$store.state.user.menu);
  }
  public toPage(path, list) {
    for (const item of list) {
      if (item.list && item.list.length > 0) {
        this.toPage(path, item.list);
      } else {
        if (item.path === path) {
          if (item.type === 0) {
            return this.$router.push({
              path,
            });
          } else if (item.type === 1) {
            return (window.location.href = item.path);
            // return window.open(item.path)
          }
        }
      }
    }
  }
}
